export default {"src":"/_next/static/media/360deg.f829c14c.svg","height":28,"width":38,"blurWidth":0,"blurHeight":0};